// Re-export the unified TablePagination as Pagination (keeping the existing name for backward compatibility)
export { TablePagination as Pagination } from "@/components/ui/pagination";
